// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--OKBOP","banner":"_0bc5e8de02--banner--G5c7r","banner--red":"_0bc5e8de02--banner--red--UFiv_"};